import React from 'react';

const Video = props => {
  const {
    controls,
    autoplay,
    loop,
    source,
    type,
    styles
  } = props;

  const _autoplay = autoplay === "true";

  const _loop = loop === "true";

  const _controls = controls === "true";

  if (_autoplay) {
    if (_loop) {
      if (_controls) {
        return (
          /*#__PURE__*/
          React.createElement("video", {
            muted: true,
            autoPlay: true,
            loop: true,
            controls: true,
            style: styles
          },
          /*#__PURE__*/
          React.createElement("source", {
            src: source,
            type: type
          }))
        );
      } else {
        return (
          /*#__PURE__*/
          React.createElement("video", {
            muted: true,
            autoPlay: true,
            loop: true,
            style: styles
          },
          /*#__PURE__*/
          React.createElement("source", {
            src: source,
            type: type
          }))
        );
      }
    } else if (_controls) {
      return (
        /*#__PURE__*/
        React.createElement("video", {
          muted: true,
          autoPlay: true,
          controls: true,
          style: styles
        },
        /*#__PURE__*/
        React.createElement("source", {
          src: source,
          type: type
        }))
      );
    } else {
      return (
        /*#__PURE__*/
        React.createElement("video", {
          muted: true,
          autoPlay: true,
          style: styles
        },
        /*#__PURE__*/
        React.createElement("source", {
          src: source,
          type: type
        }))
      );
    }
  } else if (_loop) {
    if (_controls) {
      return (
        /*#__PURE__*/
        React.createElement("video", {
          muted: true,
          loop: true,
          controls: true,
          style: styles
        },
        /*#__PURE__*/
        React.createElement("source", {
          src: source,
          type: type
        }))
      );
    } else {
      return (
        /*#__PURE__*/
        React.createElement("video", {
          muted: true,
          loop: true,
          style: styles
        },
        /*#__PURE__*/
        React.createElement("source", {
          src: source,
          type: type
        }))
      );
    }
  } else if (_controls) {
    return (
      /*#__PURE__*/
      React.createElement("video", {
        muted: true,
        controls: true,
        style: styles
      },
      /*#__PURE__*/
      React.createElement("source", {
        src: source,
        type: type
      }))
    );
  } else {
    return (
      /*#__PURE__*/
      React.createElement("video", {
        muted: true,
        style: styles
      },
      /*#__PURE__*/
      React.createElement("source", {
        src: source,
        type: type
      }))
    );
  }
};

export default Video;